(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initBGM() {
    let audio_track_index = 0;
    const containerElement = document.querySelector('#audioVisualizer');

    const musicSwitcherBtns = document.querySelectorAll('.headBgm__list .headBgm__btn');
    const musicMuteBtn = document.querySelector('.headBgm__off');

    const audioElement = document.querySelector('#audio');
    const audioWave = document.querySelector('#audioWave');

    // 1曲目のトラックをセットする
    audioElement.src = musicList[audio_track_index];

    // BGMのボリュームを少し抑える
    audioElement.volume = 0.2;

    musicMuteBtn.addEventListener('click', (e) => {
      if (audioElement.paused == true) {
        audioElement.play();
      } else {
        audioElement.pause();
      }
    });
    audioElement.addEventListener('play', (e) => {
      musicMuteBtn.textContent = 'OFF';
    });
    audioElement.addEventListener('pause', (e) => {
      musicMuteBtn.textContent = 'ON';
    });
    audioElement.addEventListener('ended', (e) => {
      // 次のトラックを再生
      console.log('track #' + (audio_track_index + 1) + ' ended.');
      // console.log(audio_track_index, musicList.length);
      // console.log(audio_track_index < musicList.length - 1);
      audio_track_index = audio_track_index < musicList.length - 1 ? ++audio_track_index : 0;
      console.log('__next track #' + (audio_track_index + 1));
      playTrack();
    });
    audioElement.addEventListener('emptied', (e) => {
      musicSwitcherBtns.forEach((btn, i) => {
        if (i === audio_track_index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });
    musicSwitcherBtns.forEach((btn, i) => {
      function changeTrack() {
        audio_track_index = i;
        playTrack();
      }
      btn.addEventListener('click', changeTrack);
    });

    window.playBGM = () => {
      audioElement.play();
    };
    function playTrack() {
      audioElement.src = musicList[audio_track_index];
      audioElement.addEventListener(
        'canplay',
        () => {
          // console.log(audioElement.ended);
          if (audioElement.ended) {
            audioElement.currentTime = 0;
          }
          audioElement.play();
        },
        {
          once: true,
        }
      );
      audioElement.load();
    }
    function startAudioVisualizer(e) {
      /** フーリエ変換を行う分割数。2の乗数でなくてはならない */
      const FFT_SIZE = 64;

      // --------------------------------
      // アナライザーの設定を行います
      // --------------------------------
      const context = new AudioContext();

      // アナライザーを生成
      const nodeAnalyser = context.createAnalyser();
      // フーリエ変換を行う分割数。2の乗数でなくてはならない
      nodeAnalyser.fftSize = FFT_SIZE;
      // 0～1の範囲でデータの動きの速さ 0だともっとも速く、1に近づくほど遅くなる
      nodeAnalyser.smoothingTimeConstant = 0.5;
      // オーディオの出力先を設定
      nodeAnalyser.connect(context.destination);

      // audio 要素と紐付ける
      const nodeSource = context.createMediaElementSource(audioElement);
      nodeSource.connect(nodeAnalyser);

      // --------------------------------
      // 繰り返し処理
      // --------------------------------
      const step = 64;
      const skip = 4;
      let count = 0;
      let direction = 1;
      const points = [];
      for (let i = 0; i < step; i++) {
        points.push({
          level: 0,
          progress: Math.floor(100 * (i / step)),
          direction: 0,
        });
      }

      loop();

      /** 描画します */
      function loop() {
        requestAnimationFrame(loop);

        // points を更新
        for (let i = 0, len = points.length; i < len; i++) {
          points[i].progress += 1;
        }

        // 波形データを格納する配列の生成
        const freqByteData = new Uint8Array(FFT_SIZE / 2);
        // それぞれの周波数の振幅を取得
        nodeAnalyser.getByteFrequencyData(freqByteData);

        count = ++count % skip;
        if (count === 0) {
          // 配列の最後の項目を削除
          points.pop();

          // 最新の平均値を出す
          let total = 0;
          for (let i = 0; i < freqByteData.length; i++) {
            const freqSum = freqByteData[i];
            // 値は256段階で取得できるので正規化して 0.0 〜 1.0 の値にする
            total += freqSum / 256;
          }
          const level = total / freqByteData.length;
          direction = direction > 0 ? -1 : 1; // 向きを交互に
          points.unshift({
            level: level,
            progress: 0,
            direction: direction,
          });
        }

        let d_str = '';
        const w_base = 24;
        const h_base = 45;
        const h_offset = 10;
        const y_unit = h_base / points.length;
        for (let i = 0, len = points.length; i < len; i++) {
          const y = (points[i].progress / 100) * (h_base + h_offset * 2) - h_offset;
          const x = 2 * ((points[i].level * w_base) / 2) * points[i].direction + w_base / 2;
          if (i === 0) {
            d_str += `M ${x}, ${y}`;
          } else {
            d_str += ` L ${x}, ${y}`;
          }
        }
        audioWave.setAttribute('d', d_str);
      }
    }
    audioElement.addEventListener('play', startAudioVisualizer, {
      once: true,
    });
  }
  initBGM();

  } catch(e) { console.error(e); }
})();
})();
